'use client';

import type { MenuProps } from '@musinsa/mds';
import {
  IcArrowDown,
  Menu,
  MenuContent,
  MenuItemContent,
  MenuTrigger,
  Typography,
} from '@musinsa/mds';
import clsx from 'clsx';
import type { FC, MouseEventHandler } from 'react';
import { useState } from 'react';
import type { ValueOf } from '../../../../common';
import { useSalesRankingFilter } from '../SalesRankingFilterProvider';

export const ORDER_BY_VALUES = {
  누적_수수료_높은_순: 'TOTAL_COMMISSION',
  판매_건_수_높은_순: 'TOTAL_QUANTITY',
} as const;

export type OrderByOption = {
  value: ValueOf<typeof ORDER_BY_VALUES>;
  label: string;
};

const ORDER_BY_OPTIONS: OrderByOption[] = [
  {
    value: ORDER_BY_VALUES.누적_수수료_높은_순,
    label: '누적 수수료 높은 순 ',
  },
  {
    value: ORDER_BY_VALUES.판매_건_수_높은_순,
    label: '판매 건 수 높은 순',
  },
];

export const OrderBySelector: FC = () => {
  const { filter, setFilter } = useSalesRankingFilter();

  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange: MenuProps['onOpenChange'] = (open: boolean) => {
    setIsOpen(open);
  };

  const handleSelect =
    (option: OrderByOption): MouseEventHandler<HTMLButtonElement> =>
    () => {
      setFilter({ ...filter, orderBy: option.value });
      setIsOpen(false);
    };

  const selected = ORDER_BY_OPTIONS.find((option) => option.value === filter.orderBy);

  return (
    <Menu open={isOpen} onOpenChange={handleOpenChange}>
      <div className="relative">
        <MenuTrigger>
          <Typography
            variant="body13pxReg"
            className="inline-flex items-center space-x-0.5 min-w-[140px] justify-end"
            asChild
          >
            <button type="button">
              <span>{selected?.label || '선택'}</span>
              <IcArrowDown width={16} height={16} className={clsx(isOpen && 'rotate-90')} />
            </button>
          </Typography>
        </MenuTrigger>
        <MenuContent asChild>
          <ul>
            {ORDER_BY_OPTIONS.map((option) => (
              <MenuItemContent
                key={option.value}
                selected={selected?.value === option.value}
                asChild
              >
                <button type="button" className="text-left w-full" onClick={handleSelect(option)}>
                  <li className="pr-[8px]!">
                    <Typography lineClamp="one">{option.label}</Typography>
                  </li>
                </button>
              </MenuItemContent>
            ))}
          </ul>
        </MenuContent>
      </div>
    </Menu>
  );
};
